import React, { useState, useEffect, useRef } from 'react';
import { Table, Tbody, Tr, Td } from 'react-super-responsive-table';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import "../css/testimonial.css";
import Loading from '../components/Loading';
import { Edit, Trash2, Download } from 'react-feather';
import withNavigation from '../components/WithNavigation';
import ReviewTemp from '../../../images/Review_template.png';
import CongratsTemp from '../../../images/Congrats_template.png';
import "../css/Font.css";

// Custom hook to dynamically resize font to fit within a box
const useFitText = (text, width, height, maxFontSize = 100, minFontSize = 10) => {
  const ref = useRef(null);
  const [fontSize, setFontSize] = useState(maxFontSize);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const fits = (size) => {
      element.style.fontSize = `${size}px`;
      return element.scrollHeight <= height && element.scrollWidth <= width;
    };

    let low = minFontSize;
    let high = maxFontSize;
    let bestFit = minFontSize;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      if (fits(mid)) {
        bestFit = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    setFontSize(bestFit);
  }, [text, width, height, maxFontSize, minFontSize]);

  return [ref, fontSize];
};

const ReviewExportCard = ({ post, exportRef, getDisplayName }) => {
  const [reviewRef, fontSize] = useFitText(post.review, 1800, 1000);

  return (
    <div
      ref={(el) => (exportRef.current[post.id] = el)}
      style={{
        width: '2400px',
        height: '2400px',
        position: 'relative',
        fontFamily: 'Futura, Arial, sans-serif',
        color: 'black',
        zIndex: 2,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '800px',
          left: '1910px',
          width: '490px',
          height: '200px',
          textAlign: 'center',
          textOverflow: 'ellipsis',
          transform: 'rotate(-29deg)',
          fontFamily: 'Arial, sans-serif',
          whiteSpace: 'nowrap',
          transformOrigin: 'left center',
          fontSize: '72px',
          fontWeight: 'bold',
          zIndex: 3,
        }}
      >
        {getDisplayName(post.name)}
      </div>

      <img
        src={post.image !== '' ? `https://yesedacademy.com/database/${post.image}` : `https://yesedacademy.com/database/images/user.png`}
        alt="profile"
        style={{
          position: 'absolute',
          top: '413px',
          right: '258px',
          width: '478px',
          height: '478px',
          transform: 'rotate(-27.5deg)',
          transformOrigin: 'left top',
          objectFit: 'cover',
          zIndex: 1,
        }}
      />

      <img
        src={ReviewTemp}
        alt="template"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '2400px',
          height: '2400px',
          zIndex: 2,
        }}
      />

      <div
        ref={reviewRef}
        style={{
          position: 'absolute',
          top: '850px',
          left: '260px',
          width: '1800px',
          height: '1000px',
          textAlign: 'center',
          fontSize: `${fontSize}px`,
          
          fontStyle: 'italic',
          fontFamily: 'Futura Condensed, Futura, Arial, sans-serif',
          overflow: 'hidden',
          zIndex: 4,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {post.review}
      </div>
    </div>
  );
};

const CongratsExportCard = ({ post, exportRef2,}) => {


  return (
    <div
      ref={(el) => (exportRef2.current[post.id] = el)}
      style={{
        width: '2400px',
        height: '2400px',
        position: 'relative',
        fontFamily: 'Futura, Arial, sans-serif',
        color: 'black',
        zIndex: 2,
      }}
    >
      <div
        style={{
          position: 'absolute',
          top: '1230px',
          width: '2400px',
          
          textAlign: 'center',
          textOverflow: 'ellipsis',
          fontFamily: 'Futura Condensed, Futura, Arial, sans-serif',
          whiteSpace: 'nowrap',
          transformOrigin: 'left center',
          fontSize: '135px',
          letterSpacing: '9px',
          lineHeight: '1',
          fontWeight: 'bold',
          textShadow: '4px 4px 8px #cf2880',
          zIndex: 3,
        }}
      >
        {post.name}
      </div>

      <img
        src={post.image !== '' ? `https://yesedacademy.com/database/${post.image}` : `https://yesedacademy.com/database/images/user.png`}
        alt="profile"
        style={{
          position: 'absolute',
          top: '510px',
          left: '850px',
          width: '725px',
          height: '725px',
          
          transformOrigin: 'left top',
          objectFit: 'cover',
          zIndex: 1,
        }}
      />

      <img
        src={CongratsTemp}
        alt="template"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '2400px',
          height: '2400px',
          zIndex: 2,
        }}
      />

    </div>
  );
};

const Posts = ({ posts, loading, handleDelete, submitLoading, submitLoading2 }) => {
  const navigate = useNavigate();
  const exportRef = useRef({});
  const exportRef2 = useRef({});

  const getDisplayName = (name, maxLength = 13) => {
    if (!name) return '';
    const parts = name.trim().split(' ');
    const first = parts[0] || '';
    const second = parts[1] || '';
    const firstSecond = `${first} ${second}`.trim();

    if (first.length > maxLength) return first;
    if (firstSecond.length <= maxLength) return firstSecond;
    return first;
  };

  const handleEdit = (postId) => {
    localStorage.setItem('reviewId', postId);
    navigate(`/edit/${postId}`);
  };

  const handleDownload = async (postId) => {
    const node = exportRef.current[postId];
    if (!node) return;

    const canvas = await html2canvas(node, { useCORS: true });
    const link = document.createElement('a');
    link.download = `Review_${postId}.jpg`;
    link.href = canvas.toDataURL('image/jpeg');
    link.click();
  };

  const handleCongratsDownload = async (postId) => {
    const node = exportRef2.current[postId];
    if (!node) return;

    const canvas = await html2canvas(node, { useCORS: true });
    const link = document.createElement('a');
    link.download = `Congrats_${postId}.jpg`;
    link.href = canvas.toDataURL('image/jpeg');
    link.click();
  };

  if (loading) {
    return <Loading size={100} />;
  }

  return (
    <>
      <Table className="responsiveTable">
        <Tbody>
          {posts.map((post) => (
            <Tr key={post.id}>
              <Td style={{ width: '100px' }}>
                <img
                  className="rounded-corners"
                  src={post.image !== '' ? `https://yesedacademy.com/database/${post.image}` : `https://yesedacademy.com/database/images/user.png`}
                  alt="avatar"
                  style={{ width: 50 }}
                />
              </Td>
              <Td>
                <p className="name">{post.name}</p>
                <p className="designation">{post.profession}</p>
                <p className="designation">{post.workplace !== ' ' && post.workplace}</p>
              </Td>
              <Td className="testimonial">
                <i className="fa fa-quote-left pe-2" />
                {post.review}
                <i className="fa fa-quote-right pe-2" />
              </Td>
              <Td>
  <div style={{ display: 'flex', gap: '8px' }}>
    <button className="no-hover" onClick={() => handleEdit(post.id)}>
      <Edit className="ico-button" />Edit
    </button>
  </div>
  <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
    {submitLoading2 === post.id ? (
      <Loading size={20} />
    ) : (
      <>
        <button className="no-hover" onClick={() => handleDownload(post.id)}>
          <Download className="ico-button" />Download
        </button>
        
      </>
    )}
  </div>
</Td>
<Td>
  <div style={{ display: 'flex', gap: '8px' }}>
    
    {submitLoading === post.id ? (
      <Loading size={20} />
    ) : (
      <button className="no-hover" onClick={() => handleDelete(post.id)}>
        <Trash2 className="ico-button" />Delete
      </button>
    )}
  </div>
  <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
    {submitLoading2 === post.id ? (
      <Loading size={20} />
    ) : (
      <>
       
        <button className="no-hover" onClick={() => handleCongratsDownload(post.id)}>
          <Download className="ico-button" />Congrats
        </button>
      </>
    )}
  </div>
</Td>

            </Tr>
          ))}
        </Tbody>
      </Table>

      <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
        {posts.map((post) => (
          <ReviewExportCard
            key={post.id}
            post={post}
            exportRef={exportRef}
            getDisplayName={getDisplayName}
          />
        ))}
      </div>
       <div style={{ position: 'absolute', left: '-9999px', top: 0 }}>
        {posts.map((post) => (
          <CongratsExportCard
            key={post.id}
            post={post}
            exportRef2={exportRef2}
            
          />
        ))}
      </div>
    </>
  );
};

export default withNavigation(Posts);
